/* eslint-disable @typescript-eslint/no-unused-expressions */
/** @format */

import useAxios from '@/hooks/useAxios.hook';
import useFetch from '@/hooks/useFetch.hook';
import { endPoint } from '@/utils';
import * as yup from 'yup';
type TProps = {
  onNext?: (number?: number) => void;
  updateState: (data?: any) => void;
  state?: any;
};
const usePhoneNumber = ({ onNext, updateState, state }: TProps) => {
  const initialValues = { phone: '' };
  const phoneValidationSchema = yup.object().shape({
    phone: yup
      .string()
      .required('Phone number is required')
      .matches(/^[0-9]+$/, 'Phone number is not valid')
      .length(10, 'Phone number must be 10 digits'),
  });
  const { fetchData, loading, error } = useAxios();

  const handleSubmit = async (
    values: any,
    { setSubmitting, setErrors }: any,
  ) => {
    const user = {
      mobile: String(values?.phone)?.trim() || '',
      role: state?.role,
    };
    const res = await fetchData({
      url: endPoint.SEND_LOGIN_OTP,
      method: 'POST',
      data: user,
    });
    if (res?.data && res?.data?.otpId) {
      updateState &&
        updateState({ otpId: res?.data?.otpId, phone: values.phone });
      onNext && onNext();
    } else if (res && res?.statusCode === 403) {
      setErrors({ phone: res?.message });
      setSubmitting(false);
    }
  };
  return {
    initialValues,
    phoneValidationSchema,
    loading,
    error,
    handleSubmit,
  };
};

export default usePhoneNumber;
